import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

import * as styles from './styles'

const StatusCellComponent = ({ value }) => (
  <Text size={11} css={value === 'Played' ? styles.playedText : {}}>{value}</Text>
)

StatusCellComponent.propTypes = {
  value: PropTypes.string,
}

export default StatusCellComponent
